import { get } from '@/services/api';

export default {
  async convertToOrder(context, { tradeInputList }) {
    console.log(`📦 Converting input string to array: ${tradeInputList}`);

    // Split the comma-separated string into an array of individual trade strings.
    const tradesArray = tradeInputList.split(',').map(item => item.trim());

    try {
      // Pass the parameters directly to the 'get' function's config object.
      // This is the standard way for axios to generate the correct URL.
      const response = await get('/indicators/convert-to-order', {
        params: {
          tradeInputList: tradesArray,
        },
      });

      console.log('📦 Fetch Orders API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Fetch Orders API error:', error);
      throw error;
    }
  },
};  